import { graphql } from '../../graphql/generated';

export const PATIENT_INFO_QUERY = graphql(`
  query PatientInfo {
    insurances {
      id
      code
      shortName
    }
  }
`);
